import { render, staticRenderFns } from "./potrait.vue?vue&type=template&id=32539782&scoped=true&"
import script from "./potrait.vue?vue&type=script&lang=js&"
export * from "./potrait.vue?vue&type=script&lang=js&"
import style0 from "./potrait.vue?vue&type=style&index=0&id=32539782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32539782",
  null
  
)

export default component.exports